import {lazy} from 'react';

export const PrintPreview = lazy(
    () => import(/* webpackChunkName: "PrintPreview" */ './PrintPreview')
);
